import {OtsUIState} from "../../ots-ui-store";

export const selectUIPipelineFlowSearchFilter = (state: OtsUIState) => state.uiPipelineFlow.searchFilter
